import React, { useState, useEffect, useContext } from 'react';
import { getImages } from '../Const';
import { ReactSortable } from "react-sortablejs";
import { LeadsContext } from '../Context/LeadsContext';

const AutoEmailerForm = () => {
    // Local autoEmailer array (instead of fetching from API)
    const [autoEmailer, setAutoEmailer] = useState([]);

    const [editableIndex, setEditableIndex] = useState(null);

    const {getEmailScriptsHtml, addEmailScript} = useContext(LeadsContext);

    // Handle field changes (subject or date)
    const handleInputChange = (input_id, field, value) => {
        setAutoEmailer(prevItems =>
            prevItems.map(item =>
                item.id === input_id ? { ...item, [field]: value } : item
            )
        );
    };

    // Add new email
    const addAutoEmailer = (email, expiration, priority) => {
        const newItem = {
            id: Date.now(),
            email,
            expiration,
            priority
        };
        setAutoEmailer(prev => [...prev, newItem]);
    };

    // Remove email
    const removeAutoEmailer = (input_id) => {
        setAutoEmailer(prevItems =>
            prevItems.filter(item => item.id !== input_id)
        );
    };

    // Update email
    /*const updateAutoEmailer = (id, priority) => {
        console.log(id, priority);
        setAutoEmailer(prevItems =>
            prevItems.map(item =>
                item.id === id ? { ...item, priority } : item
            )
        );
    };*/

    const saveChanges = async (id,script = null) => {
        const thisEmail = autoEmailer.find((email => email.id == id));

        console.log(thisEmail);

        const values = {'script_name':thisEmail.script_name,'subject':thisEmail.subject,'script':script ? script : thisEmail.script,'day':thisEmail.day,'priority':thisEmail.priority,'type':'html','do_update':true};

        const response = await addEmailScript(values);

        console.log(response);
    }

    const fetchScripts = async () => {
        const data = await getEmailScriptsHtml();

        console.log("got data",data);

        setAutoEmailer(data);
    }

    // Simulate fetchautoEmailer
    useEffect(() => {
        console.log("Fetched local autoEmailer:", autoEmailer);

        fetchScripts();
    }, []);

const handleFileUpload = (e, itemId) => {
  const file = e.target.files[0];
  if (!file) return;

  if (file.type !== "text/html") {
    alert("Please upload a valid .html file");
    e.target.value = "";
    return;
  }

  const reader = new FileReader();
  reader.onload = (event) => {
    const fileContent = event.target.result;

    // Update that particular autoEmailer item
    setAutoEmailer((prev) =>
      prev.map((item) =>
        item.id === itemId
          ? {
              ...item,
              uploadedFile: {
                name: file.name,
                content: fileContent
              }
            }
          : item
      )
    );

    saveChanges(itemId,fileContent);
  };

  //reader.readAsText(file);

  console.log(reader.readAsText(file, "UTF-8"));
};
    return (
        <>
            <div className='d-md-flex align-items-center justify-content-between mb-4'>
                <div className='md-title text-uppercase font-26 text-ldgray'>
                    Auto Emailer
                </div>
                <div>
                    {/* <button
                        type='button'
                        className='blue-transparent-btn dark-transparent-btn text-uppercase w-200'
                        onClick={() => {
                            addAutoEmailer('', new Date().toISOString().split("T")[0], autoEmailer.length);
                        }}
                    >
                        Add New
                    </button> */}
                </div>
            </div>

            <ReactSortable
                list={autoEmailer}
                setList={(currentList) => {
                    // Update order and priorities

                    //console.log(currentList);
                    //setAutoEmailer(currentList);

                    /*currentList.forEach((email, i) => {
                        updateAutoEmailer(email.id,i);
                    });
                    setAutoEmailer(currentList);*/
                }}
                handle=".ea-transparent-btn"
                animation={200}
                easing="ease-out"
            >
                {autoEmailer.map((item, index) => {
                    const isEditable = editableIndex === index;
                    return (
                        <div key={item.id} className='ea-box mb-4'>
                            <div className='d-md-flex align-items-center justify-content-between mb-2'>
                                <div className='sm-title text-uppercase font-1-1em fw-500'>
                                    {item.script_name}
                                </div>
                                <div className='d-flex align-items-center'>
                                    <input
                                        id={`file-upload-${item.id}`}
                                        type="file"
                                        accept=".html"
                                        style={{ display: "none" }}
                                        onChange={(e) => handleFileUpload(e, item.id)}
                                    />
                                    <div className="btn-group calender-dropdown custom-dropdown announcement-dropdown me-3 position-relative">
                                        <button className="btn btn-secondary dropdown-toggle text-green mt-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src={getImages('options-icons.png')} alt="options" />
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-custom dropdown-menu-end right-0">
                                            <button
                                                type="button"
                                                className="dropdown-item text-dblue font-bold text-uppercase"
                                                onClick={() => document.getElementById(`file-upload-${item.id}`).click()}
                                            >
                                                Upload
                                            </button>
                                            <button
                                                type='button'
                                                className='dropdown-item text-red font-bold text-uppercase'
                                                onClick={() => removeAutoEmailer(item.id)}
                                            >
                                                Delete
                                            </button>
                                        </ul>
                                    </div>
                                    <div>
                                        <button type='button' className='ea-transparent-btn'>
                                            <img src={getImages('reorder-material.png')} alt="reorder" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className='ea-custom-form'>
                                <div className='row align-items-end'>
                                    <div className='col-md-10'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <label>Subject</label>
                                        </div>
                                        <input
                                            name='subject'
                                            value={item.subject}
                                            className='form-control'
                                            // maxLength="50"
                                            onChange={(e) => {
                                                handleInputChange(item.id, 'subject', e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                //updateAutoEmailer(item.id, e.target.value, index);
                                                saveChanges(item.id);
                                            }}
                                        />
                                    </div>
                                    <div className='col-md-2'>
                                        <label>Day</label>
                                        <input
                                            name="day"
                                            className="form-control"
                                            value={item.day === null ? "" :  item.day}
                                            placeholder=""
                                            onChange={(e) => {
                                                handleInputChange(item.id, 'day', e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                //updateAutoEmailer(item.id, e.target.value, index);
                                                saveChanges(item.id);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                           {/* {item.uploadedFile && (
  <div className="mt-2 text-muted small">
    Uploaded: <strong>{item.uploadedFile.content}</strong>
  </div>
)} */}
                        </div>
                    );
                })}
            </ReactSortable>
        </>
    );
};

export default AutoEmailerForm;
